import intl from "react-intl-universal";
import { TbKey, TbWebhook } from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";

export const BaasApiQuickActions = ({
  onGenerateKey,
  onCreateWebhook,
  keysEnabled = true,
  webhooksEnabled = true,
}) => {
  const actions = [
    keysEnabled
      ? {
          id: "generate-key",
          label: intl.get("baas.api.quickActions.generateKey"),
          icon: TbKey,
          onClick: onGenerateKey,
        }
      : null,
    webhooksEnabled
      ? {
          id: "create-webhook",
          label: intl.get("baas.api.quickActions.createWebhook"),
          icon: TbWebhook,
          onClick: onCreateWebhook,
        }
      : null,
  ].filter(Boolean);

  if (!actions.length) return null;

  return (
    <section className="min-w-0 w-full">
      <p className="dashboard-section-label mb-3">{intl.get("baas.api.quickActionsSection")}</p>
      <div className="shortcut-scroll-row">
        {actions.map(({ id, label, icon, onClick }) => (
          <ShortcutCard key={id} onClick={onClick} icon={icon} label={label} />
        ))}
      </div>
    </section>
  );
};
